<script setup>
import { ref, onMounted } from "vue";
import api from "@/api/http";
import WidgetBox from "@/components/WidgetBox.vue";

const report = ref({
  all_record_count: 0,
  max_mortality: 0,
  min_mortality: 0,
});

const isLoading = ref(false);

const fetchReport = async () => {
  isLoading.value = true;
  try {
    const res = await api.get("/apache-score/report");
    report.value = res.data;
  } catch (e) {
    console.error("โหลดข้อมูลล้มเหลว:", e);
  } finally {
    isLoading.value = false;
  }
};

onMounted(() => {
  fetchReport();
});
</script>

<template>
  <div class="row">
    <WidgetBox
      title="All Apache Records"
      :value="report.all_record_count"
      icon="bi bi-people"
      color="primary"
    />

    <WidgetBox
      title="Min Mortality"
      :value="report.min_mortality"
      icon="bi bi-battery-low"
      color="danger"
    />

    <WidgetBox
      title="Max Mortality"
      :value="report.max_mortality"
      icon="bi bi-battery-full"
      color="info"
    />

    <!-- <WidgetBox
      title="Your Custom Data"
      :value="500"
      icon="bi bi-star"
      color="danger"
    /> -->
  </div>
</template>
